export type ProofImage = {
  src: string
  alt: string
}

/**
 * Imágenes que se muestran en el carrusel infinito debajo de las reseñas.
 * Para agregar más, solo añade otro objeto con su URL y descripción.
 */
export const proofImages: ProofImage[] = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/m1nQbgfNWwYKy85DFEggAJ/Captura_de_pantalla_2026-08-04_a_la(s)_8.04.07_a.m..png',
    alt: 'Cliente satisfecho: aumento de +97 puntos en la primera ronda',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/mCAchAHb8utL99WcuqKd1Z/Captura_de_pantalla_2026-08-04_a_la(s)_8.04.23_a.m..png',
    alt: 'Actualizaciones de clientes con aumentos de +97 y +78 puntos',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/fDwTfWTwgx8Y9Eh8q7cpGi/Captura_de_pantalla_2026-08-04_a_la(s)_8.04.45_a.m..png',
    alt: 'Testimonio de cliente con aumento de +85 puntos en 45 dias',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/7BBnL1uZwotRx23w8Wm6iW/Captura_de_pantalla_2026-08-04_a_la(s)_8.04.59_a.m..png',
    alt: 'Entregando resultados: collections y hard inquiries eliminados',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/1D3hYARSa2KCuwtWRsRxfh/Captura_de_pantalla_2026-08-04_a_la(s)_8.05.09_a.m..png',
    alt: 'Cliente que paso de 620 a 793 puntos de credito',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/7Pb4B1gmwsVz6anLHahuuk/Captura_de_pantalla_2026-08-04_a_la(s)_8.05.25_a.m..png',
    alt: 'Reporte smartcredit con aumentos de +84, +53 y +84 puntos',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/hQAzGWbC9JQpBXWT9vB746/Captura_de_pantalla_2026-08-04_a_la(s)_8.05.32_a.m..png',
    alt: 'Resultados entregados: cliente con aumento de +71 puntos',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/bmtnaaxNtrTsaCBEXcRjsW/Captura_de_pantalla_2026-08-04_a_la(s)_8.05.41_a.m..png',
    alt: 'Reporte smartcredit con aumentos de +29, +132 y +129 puntos',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/goniM2MbmztvDMKji9CB6f/Captura_de_pantalla_2026-08-04_a_la(s)_8.05.49_a.m..png',
    alt: 'Mas de $11,778 en collections eliminados en una sola ronda',
  },
]
